import React, { useContext, useEffect, useState } from "react";

const HelperMenuContext = React.createContext();

export function useHelperMenu() {
    return useContext(HelperMenuContext);
}

export function HelperMenuProvider({ children }) {
    const [isDrawerOpen, setIsDrawerOpen] = useState(true);
    const [show, setShow] = useState(false);

    function toggleOpen() {
        setIsDrawerOpen(!isDrawerOpen);
    }

    useEffect(() => {

    }, [])

    const value = {
        isDrawerOpen,
        toggleOpen,
        show,
        setShow
    };

    return <HelperMenuContext.Provider value={value}>{children}</HelperMenuContext.Provider>;
}

export default HelperMenuContext;
